import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ImageLoader from '../images/ImageLoader';
import { Button } from 'react-bootstrap';
import BonusGameOverlayComponent from './bonusGameOverlay';
import { bonusGameUrl } from '../../util';
import { getSessionStorageKey } from '../../util/sessionStorage';

var BonusGameTile = function BonusGameTile(props) {
  var _BonusGameOverlay$;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;
  var image = model.image,
      header = model.header,
      headline = model.headline,
      copy = model.copy,
      button = model.button,
      BonusGameOverlay = model.BonusGameOverlay;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOverlay = _useState2[0],
      setShowOverlay = _useState2[1];

  var handleClick = function handleClick() {
    var _sessionState$aadResp;

    var sessionState = getSessionStorageKey("account");
    var token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp = sessionState.aadResponse) === null || _sessionState$aadResp === void 0 ? void 0 : _sessionState$aadResp.jwtIdToken; // This will open the game page

    if (token) {
      // open game board in a new tab and show overlay
      window.open("".concat(bonusGameUrl, "/sso?token=").concat(token), '_blank');
      setShowOverlay(true);
    }
  };

  var hideOverlay = function hideOverlay() {
    setShowOverlay(false);
    window.location.reload();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, (BonusGameOverlay === null || BonusGameOverlay === void 0 ? void 0 : BonusGameOverlay.length) && /*#__PURE__*/React.createElement(BonusGameOverlayComponent, {
    show: showOverlay,
    hide: hideOverlay,
    model: (_BonusGameOverlay$ = BonusGameOverlay[0]) === null || _BonusGameOverlay$ === void 0 ? void 0 : _BonusGameOverlay$.fields
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-bonus-game-tile"
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: image,
    type: 'product',
    className: "cb-bonus-game-tile__bg-image"
  }), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-tile__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-tile__header'
  }, /*#__PURE__*/React.createElement(Text, {
    field: header
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-tile__headline'
  }, /*#__PURE__*/React.createElement(Text, {
    field: headline
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-tile__copy'
  }, /*#__PURE__*/React.createElement(Text, {
    field: copy
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-game-tile__button'
  }, /*#__PURE__*/React.createElement(Button, {
    className: 'cb-button-alternate cb-button-alternate--bonus-game-tile',
    onClick: handleClick
  }, button.value)))));
};

export default BonusGameTile;